<template>
  <div class="dashboard-block">
    <form>
      <h2>Account Details</h2>

      <div class="panel panel-grey">
        <div class="panel-body">
          <div class="form-horizontal">

            <div class="row">
              <div class="col-xs-12 col-lg-6">
                <field-input :model="$v.stateFirstName" field-name="First name"/>
              </div>
              <div class="col-xs-12 col-lg-6">
                <field-input :model="$v.stateLastName" field-name="Last name"/>
              </div>
            </div>

            <div class="row">

              <div class="col-xs-12 col-lg-6">
                <field-input :model="$v.stateEmail" field-name="Email"/>
              </div>

              <div class="col-xs-12 col-lg-6" v-if="user && user.region">
                <div class="form-group" :class="{ 'has-error' : $v.phoneModel.$error }">
                  <label class="control-label col-sm-4">Mobile phone:</label>
                  <div class="col-sm-8">
                    <vue-tel-input
                      ref="phone"
                      name="phone"
                      :preferred-countries="['AU', 'GB', 'US']"
                      :default-country="$user.region ? $user.region.shortname : null"
                      :auto-default-country="$user.region && $user.region.shortname ? true : false"
                      :style-classes="wrapperClasses"
                      v-model="$v.phoneModel.$model">
                      <template v-slot:arrow-icon="{ open }">{{ open ? "▲" : "▼" }}</template>
                    </vue-tel-input>

                    <vuelidate-help :field="$v.phoneModel" label="Phone number" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Admin/Client Profile Details -->

            <template>
              <div class="row">
                <div class="col-xs-12 col-lg-6">
                  <client-selection v-if="$vlastMode && $isCricketAus && userIsTalent" :model="$v.stateCompany" :default="user.company"/>
                  <field-input v-else :model="$v.stateCompany" v-bind:field-name="$t('organisation') | sentenceCase" :show-required="!userIsTalent && showClientDepartmentFields" :showDescription="!$vlastMode && (userIsClient || userIsTalent)" descriptionText="Your business name. Leave blank if not applicable"/>
                </div>
                <div class="col-xs-12 col-lg-6" v-if="userIsAdmin || userIsClient || userIsManager">
                  <field-input :model="$v.statePosition" field-name="Job Title" :show-required="showClientDepartmentFields"/>
                </div>
              </div>
            </template>

            <div class="row" v-if="$userIsAdmin">
              <div class="col-xs-12 col-lg-6" v-if="(userIsAdmin || userIsClient) && $showDepartmentField">
                <department-multiple-selection v-if="user.role === 'restricted-admin'" :model="$v.stateDepartments" :default="user.departments"/>
                <department-selection v-else :model="$v.stateDepartment" :default="user.department"/>
              </div>
              <div class="col-xs-12 col-lg-6" v-if="$userIsSuperAdmin && userIsAdmin && $vlastMode">
                <div class="form-group" :class="{ 'has-error' : $v.stateRole.$error }" >
                  <label class="control-label col-sm-4">* Role: </label>
                  <div class="col-sm-8">
                    <selectize
                      class="single selectize selectize-single selectize-bordered selectized"
                      :multiple=false
                      :class="$v.stateRole.$error ? 'has-error red-border' : ''"
                      name="role"
                      v-model="$v.stateRole.$model"
                      :options="roleOptions"/>

                    <div v-if="$v.stateRole.$error" class="help-block pull-right">Role is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="userIsClient && $paymentsModuleEnabled">
              <div class="col-xs-12 col-lg-6">
                <field-input :model="$v.stateInvoiceTo" field-name="Invoice To"/>
              </div>
            </div>

            <!-- Talent Profile Details -->
            <template v-if="userIsTalent">
              <div class="row">
                <div class="col-xs-12 col-lg-6" v-if="$genderModuleEnabled">
                  <div :class="['form-group', errorClass('profile.gender')]">
                    <label class="control-label col-sm-4">Gender:</label>
                    <div class="col-sm-8">
                      <div class="radio radio-inline radio-primary checkbox-filter-gender">
                        <input
                          type="radio"
                          name="profile.gender"
                          id="gender_male"
                          value="male"
                          v-model="$v.stateGender.$model"
                          >
                        <label for="gender_male">
                          <i class="fa fa-male"></i>
                        </label>
                      </div>
                      <div class="radio radio-inline radio-primary checkbox-filter-gender">
                        <input
                          type="radio"
                          name="profile.gender"
                          id="gender_female"
                          value="female"
                          v-model="$v.stateGender.$model">
                        <label for="gender_female">
                          <i class="fa fa-female"></i>
                        </label>
                      </div>
                      <div class="radio radio-inline radio-primary checkbox-filter-gender" v-if="!$isWSL">
                        <input
                          type="radio"
                          name="profile.gender"
                          id="gender_other"
                          value="other"
                          v-model="$v.stateGender.$model">
                        <label style="font-size: 16px; line-height: 26px;" for="gender_other">
                          Other
                        </label>
                      </div>

                      <help-block field="profile.gender"/>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-lg-6" >
                  <field-input :model="$v.stateWebsite" field-name="Star's Website"/>
                </div>

              </div>

              <div class="row" v-if="!$userIsManager && $managerModuleEnabled">
                <div class="col-xs-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label col-sm-4">Manager:</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" v-model="stateManager" disabled>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label col-sm-4">Manager Agency:</label>
                    <div class="col-sm-8">
                      <input type="text" class="form-control" v-model="stateAgency" disabled>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="$talentDateOfBirthEnabled" >
                <div class="col-md-12 col-lg-6">
                  <div class="form-group" :class="{ 'has-error' : $v.stateDateOfBirth.$error }">
                    <label class="control-label col-sm-4">* Date of Birth:</label>
                    <div class="col-sm-8">

                      <flat-pickr
                        :config="datePickerConfig"
                        class="form-control pickdate"
                        placeholder="Please select a date"
                        name="date_of_birth"
                        v-model="$v.stateDateOfBirth.$model"
                      />

                      <div class="help-block" v-if="$v.stateDateOfBirth.$error" >
                        <span v-if="!$v.stateDateOfBirth.required" >Date of birth is required</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="$userIsAdmin && !$vlastMode ">
                <div class="col-xs-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label col-sm-4">E-Sports:</label>
                    <div class="col-sm-8" style="padding-top: 15px;">
                      <toggle-button
                        v-model="$v.stateCanSetEsports.$model"
                        :sync="true"
                        :color="{ checked: $brandPrimary, unchecked: '#b7b7b7' }"
                        :labels="{ checked: 'YES', unchecked: 'NO' }"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="$retired">
                <div class="col-xs-6 flex items-center">
                  <div class="control-label">{{ $t('Retired Status') }}:</div>
                  <div class="flex justify-between spacer-l-2">
                    <div class="w-full" :class="{ 'has-error' : $v.stateRetired.$error }">
                      <div class="radio radio-primary">
                        <input
                          type="radio"
                          name="retired"
                          id="retired_active"
                          value="active"
                          v-model="$v.stateRetired.$model">
                        <label for="retired_active">
                          Active
                        </label>
                      </div>
                      <div class="radio radio-primary">
                        <input
                          type="radio"
                          name="retired"
                          id="retired_retired"
                          value="retired"
                          v-model="$v.stateRetired.$model">
                        <label for="retired_retired">
                          {{ $t('Retired') }}
                        </label>
                      </div>
                      <div v-if="$isNflClient" class="radio radio-primary">
                        <input
                          type="radio"
                          name="retired"
                          id="retired_coach"
                          value="coach"
                          v-model="$v.stateRetired.$model">
                        <label for="retired_coach">
                          {{ $t('Coach') }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="panel-footer">
          <ladda-button class="btn btn-sm btn-primary" type="submit" :click="handleUpdateDetails" :disabled="userIsAdmin && !canEditAdmin">Save Changes</ladda-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper, helpers } from 'mixins/users'
import { pick, forIn, each } from 'lodash'
import { notify } from 'utils'
import { email, required, requiredIf } from 'vuelidate/lib/validators'
import Selectize from '../ext/codium/CodiumSelectize'
import FieldInput from '../misc/FieldInput'
import DepartmentSelection from '../misc/DepartmentSelection'
import DepartmentMultipleSelection from '../misc/DepartmentMultipleSelection'
import ClientSelection from '../misc/ClientSelection'
import FlatPickr from 'vue-flatpickr-component'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper, helpers],

  validations () {
    return {
      stateFirstName: {
        required
      },
      stateLastName: {
        required
      },
      stateEmail: {
        required,
        email
      },
      phoneModel: {
        phoneValid: () => {
          if ((this && this.$refs && this.$refs.phone && this.$refs.phone.phoneObject && this.$refs.phone.phoneObject.valid) || this.$v.phoneModel.$model === '') {
            return true
          }
          return false
        }
      },
      stateDateOfBirth: {
        required: requiredIf(() => this.$talentDateOfBirthEnabled && this.userIsTalent)
      },
      stateCompany: {
        required: requiredIf(() => this.showClientDepartmentFields && !this.userIsTalent)
      },
      statePosition: {
        required: requiredIf(() => this.showClientDepartmentFields)
      },
      stateDepartment: {
        required: requiredIf(() => this.showClientDepartmentFields && this.$userIsAdmin)
      },
      stateDepartments: {
        required: requiredIf(() => this.user.role === 'restricted-admin' && this.showClientDepartmentFields && this.$userIsAdmin)
      },
      stateGender: {
        required: requiredIf(() => this.userIsTalent && this.$genderModuleEnabled)
      },
      stateRole: {
        required: requiredIf(() => this.userIsAdmin)
      },
      stateWebsite: {},
      stateCanSetEsports: {},
      stateInvoiceTo: {},
      stateRetired: {
        required: requiredIf(() => this.userIsTalent && this.$retired)
      }
    }
  },

  components: {
    FieldInput,
    DepartmentSelection,
    DepartmentMultipleSelection,
    FlatPickr,
    VuelidateHelp,
    ClientSelection,
    Selectize
  },

  computed: {
    roleOptions () {
      const options = [
        { id: 'admin', text: 'Admin' },
        { id: 'restricted-admin', text: 'Restricted Admin' },
        { id: 'reporting-admin', text: 'Reporting Admin' }
      ]
      return options
    },

    phoneModel: {
      get () {
        return this.statePhone || ''
      },
      set (value) {
        this.statePhone = value
      }
    },

    datePickerConfig () {
      return {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        maxDate: new Date()
      }
    },

    showClientDepartmentFields () {
      return this.userIsClient && this.$showDepartmentField
    },

    wrapperClasses () {
      if (this.$v.phoneModel.$invalid) {
        return 'red-border form-control'
      }
      return 'form-control'
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleUpdateDetails () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }

      const payload = pick(this.user, [
        'first_name',
        'last_name',
        'email',
        'company',
        'position',
        'can_set_esports',
        'date_of_birth',
        'profile.talent_website',
        'profile.manager',
        'profile.agency',
        'profile.retired',
        'profile.manager_email',
        'department_id',
        'departments',
        'invoice_to',
        'role'
      ])
      payload.phone = this.$refs.phone.phoneObject.number ? this.$refs.phone.phoneObject.number : null
      if (this.$genderModuleEnabled && this.userIsTalent) {
        payload.profile.gender = this.user.profile.gender
      }

      return this.updateUser({id: this.user.id, payload})
        .then(() => {
          notify.success('Successfully saved account details.')
          // remove custom errors added to the bag
          this.errors.clear()
        })
        .catch((errors) => {
          if (errors.response && errors.response.status === 422) {
            forIn(errors.response.data.errors, (errors, key) => {
              each(errors, error => notify.error(error))
            })
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw errors
          }
        })
    }
  }
}
</script>
